<script>
    // 통합 이미지 라이브러리(P4) — 콘솔 전역 관리 화면.
    // 특정 봇/챗에 매이지 않고 "계정 전체" 자산을 루트에서 트리로 드릴다운·관리한다.
    // 저장/스코프는 서버가 세션 오너로 처리(P1)하므로 chatId/contextFolder 없이 embedded로 연다.
    // embedded=관리 전용 뷰(업로드·폴더·버전/롤백·이동·이름변경·삭제. 선택 dispatch 없음).
    import ImagePicker from "./chat-builder/ImagePicker.svelte";

    export let currentRoute;
    export let params = {};
</script>

<div class="asset-library-page">
    <div class="asset-library-inner">
        <header class="asset-library-head">
            <h1>이미지 라이브러리</h1>
            <p>계정의 모든 이미지를 폴더로 관리하세요. 봇·챗 빌더에서 여기 이미지를 그대로 불러 쓸 수 있습니다.</p>
        </header>
        <ImagePicker embedded />
    </div>
</div>

<style>
    .asset-library-page {
        width: 100%;
        min-height: calc(100vh - 80px);
        box-sizing: border-box;
        padding: 24px 16px 48px;
    }
    .asset-library-inner {
        max-width: 1180px;
        margin: 0 auto;
    }
    .asset-library-head {
        margin-bottom: 16px;
    }
    .asset-library-head h1 {
        margin: 0 0 4px;
        font-size: 22px;
        font-weight: 700;
        color: #1c2333;
    }
    .asset-library-head p {
        margin: 0;
        font-size: 13px;
        color: #6b7280;
    }
</style>
